import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-key-pair-dialog',
    imports: [],
    templateUrl: './confirm-key-pair-dialog.component.html',
    styleUrl: './confirm-key-pair-dialog.component.scss'
})
export class ConfirmKeyPairDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmKeyPairDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
